<template>
  <share-standard
    :url="url"
    :published="true"
    @go-ahead="handleGoAhead"
  ></share-standard>
</template>
<script>
import ShareStandard from "@/components/common/ShareStandard";

function obtainUrl(mode, uniqueId) {
  const { origin, pathname } = window.location;
  if (mode === "hash") {
    return `${origin}${pathname}#/table/${uniqueId}`;
  }
  return `${origin}/table/${uniqueId}`;
}

export default {
  name: "table-publish-notify",
  components: {
    ShareStandard,
  },
  props: {
    uniqueId: String,
  },
  computed: {
    url() {
      return obtainUrl(this.$router.mode, this.uniqueId);
    },
  },
  methods: {
    handleGoAhead() {
      this.$router.push({
        name: "template",
        query: { type: 2 },
      });
    },
  },
};
</script>
